export const credit = {
    rate: 15.60/100,
    terms: [ 12, 24, 36, 48, 60 ],
    paymentPeriod: 12,
}  